import type { MeResponse } from '../../../entities/me/me-contract.types';
import { ApiError } from '../../../shared/api/api-error';

export type TrainerPlacementBranchOption = {
  branch_id: number;
  branch_name: string;
};

/** Уникальные филиалы из `trainer_placements` (по `branch_id`). */
export function uniqueTrainerPlacementBranches(
  me: MeResponse | null | undefined
): TrainerPlacementBranchOption[] {
  const placements = me?.trainer_placements;
  if (!placements?.length) return [];
  const byId = new Map<number, string>();
  for (const p of placements) {
    const bid = p.branch_id;
    if (bid == null || !Number.isFinite(bid) || bid <= 0) continue;
    if (!byId.has(bid)) {
      const name = (p.branch_name ?? '').trim();
      byId.set(bid, name || `Филиал #${bid}`);
    }
  }
  return [...byId.entries()]
    .map(([branch_id, branch_name]) => ({ branch_id, branch_name }))
    .sort((a, b) => a.branch_id - b.branch_id);
}

/** Нужен явный выбор активного филиала: несколько площадок или активный филиал ещё не выбран. */
export function trainerNeedsActiveBranchPicker(me: MeResponse | null | undefined): boolean {
  const branches = uniqueTrainerPlacementBranches(me);
  if (branches.length === 0) return false;
  if (branches.length > 1) return true;
  const active = me?.active_branch_id;
  return active == null || !branches.some((b) => b.branch_id === active);
}

export function isTrainerBranchRequiredApiError(e: unknown): boolean {
  return e instanceof ApiError && e.status === 403 && e.errorCode === 'TRAINER_BRANCH_REQUIRED';
}
